module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/hk-5a1122079f786b82c2ed4938e65caa7e.svg";